import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/header';
import Sidebar from '../../components/sidebar';
import Footer from '../../components/footer';
import { Paginator } from 'primereact/paginator';

function Marketing() {
    const [marketingData, setMarketingData] = useState([]);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(5);
    const navigate = useNavigate();

    const getMarketingData = async () => {
        try {
            const response = await axios.get('https://api.trucoo.in/marketing/view/', {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });
            if (response.data.status === 'success') {
                setMarketingData(response.data.data);
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
        }
    };

    const onPageChange = (event) => {
        setFirst(event.first);
    };

    useEffect(() => {
        getMarketingData();
    }, []);

    return (
        <>
            <Header />
            <Sidebar />

            <div className="content-wrapper">
                <div className="container-full">
                    <section className="content">
                        <div className="box">
                            <div className="box-header with-border">
                                <h4 className="box-title">Marketing Employees</h4>
                                <p className="mb-0 box-subtitle">List of all marketing employees</p>
                            </div>
                            <div className="box-body">
                                <div className="table-responsive">
                                    <table className="table text-fade table-bordered table-hover display nowrap margin-top-10 w-p100">
                                        <thead>
                                            <tr className="text-dark">
                                                <th>S.No</th>
                                                <th>Employee ID</th>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Phone</th>
                                                <th>Position</th>
                                                <th>View More</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {marketingData.length > 0 ? marketingData.slice(first, first + rows).map((employee, index) => (
                                                <tr key={index}>
                                                    <td>{index + first + 1}</td>
                                                    <td>{employee.employeeId}</td>
                                                    <td>{employee.employeeName}</td>
                                                    <td>{employee.employeeEmail}</td>
                                                    <td>{employee.employeePhone || 'N/A'}</td>
                                                    <td>{employee.position}</td>
                                                    <td>
                                                        <button 
                                                            onClick={() => navigate(`/sales-report-details?id=${employee.id}`)} 
                                                            className="btn btn-primary">
                                                            View
                                                        </button>
                                                    </td>
                                                </tr>
                                            )) : (
                                                <tr>
                                                    <td colSpan={7}>No Marketing Employees Found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                    <Paginator className="custom-paginator" first={first} rows={rows} totalRecords={marketingData?.length} onPageChange={onPageChange} />
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>

            <Footer />
        </>
    );
}

export default Marketing;